module.exports = __webpack_public_path__ + "img/verify_finer_print.db231a77.svg";